import * as _ from 'lodash';
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IArrayResponse } from '@nkr/store/index';
import { ActionsAdminOpoPayable, IOpoSemesterPayable } from '@nkr/store/billing/actions-admin-opo-payable';
import OpoPayableRow from './opo-payable-row';
import { ISortSelection, SortHeader, sortList } from '@nkr/components/sort-helper';
import { IBaseResponse } from '@nkr/models/base-response';

interface IProps { }

interface IStateProps {

}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPayables: (isPaid: boolean, hasAch: boolean) => Promise<IArrayResponse<IOpoSemesterPayable>>,
    updatePayable: (payable: IOpoSemesterPayable) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    isPaid: boolean,
    hasAch: boolean,
    sortSelection: ISortSelection,
    list: IOpoSemesterPayable[]
}

class OpoPayablesIndex extends React.Component<TProps, IState> {
    readonly state: IState = {
        isPaid: false,
        hasAch: true,
        sortSelection: {
            sortProperty: 'semesterEndDateTime',
            sortAsc: true
        },
        list: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let isPaid = this.state.isPaid;
        let hasAch = this.state.hasAch;

        this.props.showLoading('Getting payables, one moment please...').then(() => {
            this.props.getPayables(isPaid, hasAch)
                .then((response: IArrayResponse<IOpoSemesterPayable>) => {
                    if (response.data.success) {
                        this.setState({
                            list: response.data.results
                        });
                    }
                })
                .finally(() => { this.props.hideLoading(); });
        });
    }

    handlePaidSearchToggle = (e) => {
        var isPaid = e.target.value === 'true';
        this.setState({ isPaid: isPaid }, () => this.getData());
    }

    handleAchSearchToggle = (e) => {
        var hasAch = e.target.value === 'true';
        this.setState({ hasAch: hasAch }, () => this.getData());
    }

    handleUpdatePayable = (payable : IOpoSemesterPayable) => {
        return this.props.updatePayable(payable)
            .then((response: IBaseResponse) => {
                if (response.data.success) {
                    this.getData();
                }

                return response;
            });
    }

    handleUpdateSort = ( selection : ISortSelection ) => {
        this.setState({sortSelection : selection});
    }

    render = () => {
        let rows = sortList<IOpoSemesterPayable>(this.state.list, this.state.sortSelection);

        return (
            <div style={{ paddingTop: 20 }}>
                <div className='well well-sm'>
                    <div className='row'>
                        <div className='col-xs-6 col-sm-3 col-lg-2'>
                            <div className='btn-group' data-toggle='buttons'>
                                <button type='button' className={'btn ' + (this.state.isPaid == false ? 'btn-primary active' : 'btn-default')} value='false' onClick={this.handlePaidSearchToggle}>To-Do</button>
                                <button type='button' className={'btn ' + (this.state.isPaid == true ? 'btn-primary active' : 'btn-default')} value='true' onClick={this.handlePaidSearchToggle}>Paid</button>
                            </div>
                        </div>

                        <div className='col-xs-6 col-sm-3 col-lg-2'>
                            <div className='btn-group' data-toggle='buttons'>
                                <button type='button' className={'btn ' + (this.state.hasAch == true ? 'btn-primary active' : 'btn-default')} value='true' onClick={this.handleAchSearchToggle}>Has ACH</button>
                                <button type='button' className={'btn ' + (this.state.hasAch == false ? 'btn-primary active' : 'btn-default')} value='false' onClick={this.handleAchSearchToggle}>No ACH</button>
                            </div>
                        </div>
                    </div>
                </div>

                {rows.length > 0 ?
                    <div style={{ height: '76vh', overflowY: 'scroll' }}>
                        <table className='table table-striped table-nkr-styled table-condensed table-nkr-opo'>
                            <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th style={{ width: '20%' }}><SortHeader label='OPO' sortProperty='opoAlias' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='ACH' sortProperty='opoHasAchOnFile' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='TXPs' sortProperty='transplantCount' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='Period' sortProperty='semesterEndDateTime' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='Invoiced' sortProperty='totalInvoiced' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='Paid On' sortProperty='paymentDateTime' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='Payment' sortProperty='paymentAmount' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th><SortHeader label='Confirmation #' sortProperty='paymentAchConfirmation' sortDefaultAsc={true} sortSelection={this.state.sortSelection} onClick={this.handleUpdateSort} /></th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item, index) =>
                                    <OpoPayableRow key={`${item.opoId}_${item.semesterEndDateTime}`} rank={index + 1} data={item} onUpdatePayable={this.handleUpdatePayable} />
                                )}
                            </tbody>
                        </table>
                    </div>
                    :
                    <div className='alert alert-danger'>No date was found</div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPayables: (isPaid, hasAch) => {
            return dispatch(ActionsAdminOpoPayable.getOpoPayables(isPaid, hasAch));
        },
        updatePayable: (payable: IOpoSemesterPayable) => {
            return dispatch(ActionsAdminOpoPayable.updateOpoPayable(payable));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(OpoPayablesIndex);